import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type EmptyStateProps = {
  type: "transactions" | "invoices";
};

const EmptyState = ({ type }: EmptyStateProps) => {
  const { t } = useTranslation("plans", { keyPrefix: "page.plansOverviewPage" });

  return (
    <Box
      component="figure"
      sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "24px", py: 4 }}
    >
      <Typography
        component="h3"
        sx={{
          color: "var(--Dark---1000, #111)",
          textAlign: "center",
          fontFamily: "Montserrat",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "32px",
        }}
      >
        {type === "transactions" ? t("noTransactions") : t("noInvoices")}
      </Typography>
    </Box>
  );
};

export default EmptyState;

